var map = {
	"./arte_saber.jpeg": "8ZyI",
	"./bambini.jpg": "K0Zc",
	"./castelo-escola.png": "fYua",
	"./cei.png": "kJ5b",
	"./ces.jpg": "Amp/",
	"./chapeu.png": "oOu2",
	"./colegio_br.png": "MKQ1",
	"./conexao_aba.jpeg": "/fZe",
	"./diogenes.png": "fYIC",
	"./espaco_crianca.jpeg": "G/co",
	"./iep.png": "wsTx",
	"./infante.jpg": "K6Q/",
	"./jorge_lima.png": "lsKL",
	"./marie_jost.png": "Ng0A",
	"./ser-aprender.png": "TlpQ",
	"./smart-kids.png": "JaX/",
	"./vila_rica.jpg": "qZUv",
	"./virginio_augusto.png": "wS5I"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VT3Z";